export enum SITE_URL {
  NOSOTROS = '/nosotros',
  COMO_COMPRAR = '/como-comprar',
  POLITICAS_DEVOLUCIONES = '/devoluciones',
  POLITICAS_PRIVACIDAD = '/politicas-de-privacidad',
  PREGUNTAS_FRECUENTES = '/preguntas-frecuentes',
  SITE_FACEBOOK = 'https://www.facebook.com/enova.ar',
  SITE_INSTAGRAM = 'https://www.instagram.com/enova.ar',
}
